export enum InvitationCodeEnum {
  DEFAULT = 'VIPBB',
}
